var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "axios", "./modules/constants", "./modules/services/toastNotification", "./modules/utils/selfServiceRouteHelper"], function (require, exports, axios_1, constants_1, toastNotification_1, selfServiceRouteHelper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MfaModal = void 0;
    axios_1 = __importDefault(axios_1);
    selfServiceRouteHelper_1 = __importDefault(selfServiceRouteHelper_1);
    var MfaModal = (function () {
        function MfaModal(mfaSize, formToSubmit) {
            var _this = this;
            var _a;
            this._base_url = "mfa";
            this._modalElement = document.querySelector('#mfa-modal');
            this._remainingTimeSpan = document.querySelector('#tempo-restante');
            this._mfaFieldsSection = document.querySelector('#mfa-fields-section');
            this._btnVerify = document.querySelector('#btn-verify');
            this._iconClose = document.querySelector('#mfa-modal-close');
            this._newMfa = document.querySelector('#new-mfa');
            this._mfaExpiration = document.querySelector("#mfa-expiration");
            this._mfaValueClass = "mfa-value";
            this._disabledClassList = selfServiceRouteHelper_1.default.isSelfService() ? ['bg-linx-purple-transparent-100', 'text-white', 'cursor-not-allowed'] : ['cursor-not-allowed', 'bg-linx-purple-300'];
            this._enabledClassList = selfServiceRouteHelper_1.default.isSelfService() ? ['cursor-pointer', 'bg-linx-purple-1100', 'hover:bg-linx-purple-1200'] : ['cursor-pointer', 'bg-linx-purple-500', 'hover:bg-linx-purple-600'];
            this.VerifyMfa = function (mfa) { return __awaiter(_this, void 0, void 0, function () {
                var endpoint, url;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            endpoint = selfServiceRouteHelper_1.default.isSelfService() ? 'verify-self-service' : 'verify-backoffice';
                            url = this._base_url + "/" + endpoint + "/" + mfa;
                            return [4, axios_1.default.get(url)];
                        case 1: return [2, _a.sent()];
                    }
                });
            }); };
            this.GenerateNewMfa = function (e) {
                e.preventDefault();
                _this._formToSubmit.submit();
            };
            this.Show = function () {
                document.querySelector('#mfa-modal').classList.remove('hidden');
            };
            this.Close = function () {
                document.querySelector('#mfa-modal').classList.add('hidden');
            };
            this.VerifyTypedMfa = function () { return __awaiter(_this, void 0, void 0, function () {
                var inputs, values, mfaCode, result, error_1, mfaFailedResult;
                var _a, _b, _c, _d, _e, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            _g.trys.push([0, 2, , 3]);
                            inputs = document.querySelectorAll("." + this._mfaValueClass);
                            values = Array.from(inputs).map(function (input) { return input.value; });
                            mfaCode = values.join('');
                            return [4, this.VerifyMfa(mfaCode.toUpperCase())];
                        case 1:
                            result = _g.sent();
                            if ((_a = result === null || result === void 0 ? void 0 : result.data.data) === null || _a === void 0 ? void 0 : _a.succeeded) {
                                this.Close();
                                toastNotification_1.ToastNotification.Success("Código verificado com sucesso.");
                                this._formToSubmit.submit();
                                return [2];
                            }
                            return [3, 3];
                        case 2:
                            error_1 = _g.sent();
                            console.error(error_1);
                            mfaFailedResult = JSON.parse((_b = error_1.response) === null || _b === void 0 ? void 0 : _b.data.data).data;
                            toastNotification_1.ToastNotification.Error((_f = (_c = mfaFailedResult.mensagem) !== null && _c !== void 0 ? _c : (_e = (_d = error_1.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : "O código informado é inválido.", constants_1.defaultToastMs);
                            this.ClearInputs();
                            if (mfaFailedResult.tentativasRestantes === 0)
                                this.Close();
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            }); };
            this.RenderMfaFields = function (mfaSize) {
                var fields = '';
                for (var i = 0; i < mfaSize; i++)
                    fields += _this.MfaInputTemplate();
                _this._mfaFieldsSection.innerHTML = fields;
                document.querySelectorAll("." + _this._mfaValueClass).forEach(function (input, index, inputs) {
                    input.addEventListener('input', function () {
                        if (input.value.length === input.maxLength) {
                            var nextInput = inputs[index + 1];
                            if (nextInput) {
                                nextInput.focus();
                            }
                            else {
                                _this._btnVerify.focus();
                            }
                        }
                    });
                    input.addEventListener('focus', function () {
                        input.select();
                    });
                    input.addEventListener('focusout', function () {
                        var allHaveValue = Array.from(inputs).every(function (input) { return input.value.trim() !== ''; });
                        if (allHaveValue) {
                            _this.EnableVerifyButton();
                        }
                        else {
                            _this.DisableVerifyButton();
                        }
                    });
                });
            };
            this.DisableVerifyButton = function () {
                var _a, _b;
                (_a = document.querySelector('#btn-verify').classList).remove.apply(_a, _this._enabledClassList);
                (_b = document.querySelector('#btn-verify').classList).add.apply(_b, _this._disabledClassList);
                _this._btnVerify.removeEventListener('click', _this.VerifyTypedMfa);
            };
            this.EnableVerifyButton = function () {
                var _a, _b;
                (_a = document.querySelector('#btn-verify').classList).remove.apply(_a, _this._disabledClassList);
                (_b = document.querySelector('#btn-verify').classList).add.apply(_b, _this._enabledClassList);
                _this._btnVerify.addEventListener('click', _this.VerifyTypedMfa);
            };
            this.ClearInputs = function () {
                document.querySelectorAll("." + _this._mfaValueClass).forEach(function (input) {
                    input.value = '';
                });
            };
            this.MfaInputTemplate = function () { return selfServiceRouteHelper_1.default.isSelfService() ?
                "<input type=\"text\" maxlength=\"1\" class=\"" + _this._mfaValueClass + " w-10 h-10 uppercase rounded leading-tight appearance-none bg-white border border-gray-400 hover:border-gray-500 focus:border-gray-600 focus:outline-none px-4 py-3 pr-8 shadow\" />"
                :
                    "<input type=\"text\" maxlength=\"1\" class=\"" + _this._mfaValueClass + " w-10 h-10 uppercase text-center appearence-none bg-gray-100 border border-gray-400 hover:border-gray-500 focus:border-gray-600 focus:outline-none px-4 py-3 shadow leading-tight\" />"; };
            this._formToSubmit = formToSubmit;
            this._iconClose.addEventListener('click', this.Close);
            this._newMfa.addEventListener('click', this.GenerateNewMfa);
            this.RenderMfaFields(mfaSize);
            this.Show();
            this.DisableVerifyButton();
            (_a = document.querySelector("." + this._mfaValueClass)) === null || _a === void 0 ? void 0 : _a.focus();
        }
        return MfaModal;
    }());
    exports.MfaModal = MfaModal;
});
